export const strings = {
  AddBlogsBtn: "Add a new Blog",
  BlogPageTitle: 'All Blogs',
  blogEditBtn: "Edit",
  DeleteBtn: "Delete",
  EditBlogTitle: "Edit Post: ",
  addBlogTitle: "Add A Post: ",
  inputTitle: "Title",
  titlePlaceholder: "Title here",
  inputCategory: "Category",
  categoryPlaceholder: "Category here",
  inputDesc: "Description",
  descriptionPlaceholder: "Description here",
  inputBlogger: "Blogger",
  submitButton: "Upload",
  uploadDesc1: "Click to Upload, ",
  uploadDesc2: " or Drag and Drop",
  uploadDesc3: "SVG, PNG, JPG or GIF (max. 800x400px)",
  deleteTitle: "Delete Blog Post",
  deleteDesc:
    "Are you sure you want to delete this blog post? This action cannot be undone!",

  cancelBtn: "Cancel",
  blogImage: "Blog Image",
  bloggerImage: "Blogger Image",
  JobPageTitle: "All Jobs",
};
